import { useContext } from 'react';
import { ItemContext } from '../context/ItemContext';

const useItem = () => {
  return useContext(ItemContext);
};

export default useItem;
